export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_ORGANIZATION = 'SET_CURRENT_ORGANIZATION';
export const GET_ORGANIZATIONS_LIST = 'GET_ORGANIZATIONS_LIST';
export const GET_ORDERS_LIST = 'GET_ORDERS_LIST';
export const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
export const GET_ORDER_ACTIVE_ID = 'GET_ORDER_ACTIVE_ID';
export const GET_USERS_LIST = 'GET_USERS_LIST';
export const SET_USER = 'SET_USER';
export const GET_CLIENTS_LIST = 'GET_CLIENTS_LIST';
